import GlpUpload from './GlpUpload.vue'

export { GlpUpload }
